import { useRoute, useRouter } from "vue-router";
import zhCn from "element-plus/es/locale/lang/zh-cn";
import { onMounted, getCurrentInstance, reactive } from "vue";
import moment from "moment";
import { freightUnitTypeMap, invoiceSuccessList, invoiceTypeList } from "@/util/type";
import { phoneDesc } from "@/util";
export default {
  name: "InvoiceHistoryDetail",
  setup() {
    const router = useRouter();
    const route = useRoute();
    const internal = getCurrentInstance();
    const globalProperties = internal?.appContext.config.globalProperties;
    const data = reactive({
      amount: "",
      bankNo: "",
      phone: "",
      monthSettleServiceNo: "",
      invoiceItems: "",
      invoiceNo: "",
      invoiceTime: "",
      name: "",
      openBank: "",
      list: [],
      taxNo: "",
      status: "",
      invoiceType: "",
      wordAddress: "",
      page: 1,
      size: 10,
      total: 0
    });
    onMounted(() => {
      monthSelectInvoiceDetail();
    });
    const monthSelectInvoiceDetail = async () => {
      const {
        amount,
        bankNo,
        phone,
        monthSettleServiceNo,
        invoiceItems,
        invoiceNo,
        invoiceTime,
        name,
        openBank,
        list: {
          records,
          size,
          total,
          current
        },
        taxNo,
        status,
        invoiceType,
        wordAddress
      } = await globalProperties.$api.monthSelectInvoiceDetail({
        monthSettleServiceId: route.query.monthSettleServiceId,
        page: data.page,
        size: data.size
      });
      data.list = records;
      data.page = current;
      data.total = total;
      data.size = size;
      data.amount = amount;
      data.bankNo = bankNo;
      data.phone = phone;
      data.monthSettleServiceNo = monthSettleServiceNo;
      data.invoiceItems = invoiceItems;
      data.invoiceNo = invoiceNo;
      data.invoiceTime = invoiceTime;
      data.name = name;
      data.taxNo = taxNo;
      data.openBank = openBank;
      data.status = status;
      data.invoiceType = invoiceType;
      data.wordAddress = wordAddress;
    };
    const currentChange = page => {
      data.page = page;
      data.size = 10;
      monthSelectInvoiceDetail();
    };
    return {
      currentChange,
      data,
      zhCn,
      invoiceSuccessList,
      moment,
      freightUnitTypeMap,
      phoneDesc,
      invoiceTypeList
    };
  }
};